import e from "@dialpad/dialtone-tokens/layered/themes/tokens-101-colors.css?inline";
//#region themes/101.js
var t = { brand: {
	css: e,
	name: "101"
} };
//#endregion
export { t as default };
